import React, { useState, useRef, useEffect } from "react";
import { Button, Container, Dropdown, Card } from "react-bootstrap";
import Header2 from "../component/Header2";
import MapList from "../assets/images/view-icon/map-list.svg";
import Map from "../assets/images/view-icon/map.svg";
import List from "../assets/images/view-icon/list.svg";
import Like from "../assets/images/like.svg";
import bed from "../assets/images/bed.svg";
import bath from "../assets/images/bath.svg";
import size from "../assets/images/scale.svg";
import { Link, useLocation } from "react-router-dom";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination } from "swiper/modules";
import { BASE_URL } from "../api/constants";
import BuyHeader, { getBuyHeaderText } from "../component/BuyHeader";
import useFavoritesList from "../hooks/useFavoritesList";
import FilterBar from "../component/FilterBar";
import usePropertySort from "../hooks/usePropertySort";
import { Helmet } from "react-helmet-async";

function Buy() {
  const { isFavorite, toggleFavorite } = useFavoritesList();
  const location = useLocation();

  const [view, setView] = useState(window.innerWidth < 768 ? "list" : "both");
  const headerRef = useRef(null);
  const filterRef = useRef(null);
  const [resultHeight, setResultHeight] = useState("60vh");
  const [sort, setSort] = useState("Sort by");
  //Listings
  const [residential_listings, setResidentialListings] = useState([]);
  const [county, setCounty] = useState("Nairobi");

  const getResidentialProperties = async () => {
    try {
      // Read current URL query parameters
      const params = new URLSearchParams(window.location.search);
      const property_type = params.get("property_type") || "residential";
      const listing_type = params.get("listing_type") || "sale";
      const sale_type = params.get("sale_type"); // optional
      const open_house = params.get("open_house"); // optional
      const category = params.get("category"); // optional

      // Build the fetch URL dynamically
      let url = `${BASE_URL}/properties?property_type=${property_type}&listing_type=${listing_type}`;
      if (sale_type) url += `&sale_type=${sale_type}`;
      if (open_house) url += `&open_house=${open_house}`;
      if (category) url += `&category=${category}`;

      const res = await fetch(url);
      const data = await res.json();
      console.log(data.data);

      if (data?.status && Array.isArray(data.data)) {
        setResidentialListings(data.data);
      } else {
        setResidentialListings([]);
      }
    } catch (err) {
      console.error(err);
      setResidentialListings([]);
    }
  };

  useEffect(() => {
    const updateHeight = () => {
      const headerH = headerRef.current?.offsetHeight || 0;
      const filterH = filterRef.current?.offsetHeight || 0;
      const h = Math.max(0, window.innerHeight - headerH - filterH);
      setResultHeight(`${h}px`);
    };
    updateHeight();
    getResidentialProperties();
    window.addEventListener("resize", updateHeight);
    return () => window.removeEventListener("resize", updateHeight);
  }, []);

  const sortedListings = usePropertySort(residential_listings, sort);
  const headingText = getBuyHeaderText(new URLSearchParams(location.search));
  const searchParams = new URLSearchParams(location.search);
  const hasTitleFilter =
    searchParams.has("property_type") ||
    searchParams.has("listing_type") ||
    searchParams.has("sale_type") ||
    searchParams.has("category") ||
    searchParams.get("open_house") === "true";
  const pageTitle = hasTitleFilter ? `Buy | ${headingText}` : "Buy | Jambobay";

  const mapVisible = view === "both" || view === "map";
  const listVisible = view === "both" || view === "list";

  return (
    <>
      <Helmet>
        <title>{pageTitle}</title>
        <meta
          name="description"
          content="Browse homes for sale and find your next property on Jambobay."
        />
        <meta
          name="keywords"
          content="Buy, Jambobay, Homes for Sale, Properties, Real Estate"
        />
      </Helmet>
      <div className="buy-main">
        <div ref={headerRef}>
          <Header2 />
        </div>
        <div className="buy-filter" ref={filterRef}>
          <div className="view-box">
            <div className="filter-group">
              <Button
                className={`map-list d-none d-md-flex ${view === "both" ? "active" : ""}`}
                onClick={() => setView("both")}
                aria-pressed={view === "both"}
              >
                <img src={MapList} alt="" />
              </Button>
              <Button
                className={`map ${view === "map" ? "active" : ""}`}
                onClick={() => setView("map")}
                aria-pressed={view === "map"}
              >
                <img src={Map} alt="" />
              </Button>
              <Button
                className={`list ${view === "list" ? "active" : ""}`}
                onClick={() => setView("list")}
                aria-pressed={view === "list"}
              >
                <img src={List} alt="" />
              </Button>
            </div>
          </div>

          <FilterBar onSuburbChange={(suburb) => setCounty(suburb)} />
        </div>
        <div className="result-box" style={{ height: resultHeight }}>
          <div
            className="result-map"
            style={{
              animation: mapVisible
                ? "slideInLeft 0.4s ease-in-out forwards"
                : "slideOutRight 0.4s ease-in-out forwards",
              flex:
                view === "both" ? "1" : view === "map" ? "1 1 100%" : "0 0 0",
              overflow: "hidden",
              minHeight: 0,
              display: mapVisible ? "flex" : "none",
            }}
          >
            <iframe
              title="Google Maps"
              style={{ width: "100%", height: "100%", border: 0 }}
              src={`https://maps.google.com/maps?q=${encodeURIComponent(county + ", Kenya")}&output=embed`}
              allowFullScreen
              loading="lazy"
            />
          </div>
          <div
            className={`result-list ${view === "list" ? "list-open" : ""}`}
            style={{
              animation: listVisible
                ? "slideInRight 0.4s ease-in-out forwards"
                : "slideOutLeft 0.4s ease-in-out forwards",
              flex:
                view === "both" ? "1" : view === "list" ? "1 1 100%" : "0 0 0",
              overflowY: "auto",
              minHeight: 0,
              display: listVisible ? "block" : "none",
            }}
          >
            <div className="result-list-header d-flex justify-content-between align-items-center">
              <BuyHeader />
              <span>
                {sortedListings.length} result
                {sortedListings.length === 1 ? "" : "s"}
              </span>
              <Dropdown align="end" onSelect={(key) => key && setSort(key)}>
                <Dropdown.Toggle id="sort-dropdown">
                  {sort === "Sort by" ? <>Sort by</> : <>{sort}</>}
                </Dropdown.Toggle>

                <Dropdown.Menu>
                  {[
                    "Price (High to Low)",
                    "Price (Low to High)",
                    "Newest",
                    "Bedrooms",
                    "Bathrooms",
                    "Square Feet",
                  ].map((opt) => (
                    <Dropdown.Item
                      key={opt}
                      eventKey={opt}
                      active={sort === opt}
                    >
                      {opt}
                    </Dropdown.Item>
                  ))}
                </Dropdown.Menu>
              </Dropdown>
            </div>
            <ul>
              {sortedListings?.map((item) => (
                <li key={item.id}>
                  <Link to={`/buy-details/${item.slug}`}>
                    <div className="result-item-img position-relative">
                      <Swiper
                        modules={[Autoplay, Pagination]}
                        spaceBetween={20}
                        centeredSlides={true}
                        slidesPerGroup={1}
                        // loop={true}
                        // autoplay={{ delay: 2500, disableOnInteraction: false }}
                        pagination={{ clickable: true }}
                      >
                        {item.images.length > 0 &&
                          item.images.slice(0, 3).map((url, idx) => (
                            <SwiperSlide key={idx}>
                              <Card className="border-0">
                                <Card.Img src={url.image} />
                              </Card>
                            </SwiperSlide>
                          ))}
                      </Swiper>

                      {item.tag && (
                        <span className="recommended">{item.tag}</span>
                      )}
                      <span
                        key={item.id}
                        role="button"
                        tabIndex={0}
                        className={`wishlist ${isFavorite(item.id) ? "active" : ""}`}
                        onClick={(e) => {
                          e.preventDefault();
                          toggleFavorite(item.id);
                        }}
                        onKeyDown={(e) => {
                          if (e.key === "Enter") toggleFavorite(item.id);
                        }}
                      >
                        <img src={Like} alt="like" />
                      </span>
                    </div>
                    <div className="result-item-info">
                      <h2>KES{item.price}</h2>
                      <p>{item.street_address}</p>
                      <div className="info-box">
                        <span>
                          <img src={bed} alt="" /> {item.details.bedrooms}
                        </span>
                        <span>
                          <img src={bath} alt="" /> {item.details.bathrooms}
                        </span>
                        <span>
                          <img src={size} alt="" /> {item.size_sqft}
                        </span>
                      </div>
                      <h6>
                        Listing by : <span>{item.listing_by?.name}</span>
                      </h6>
                    </div>
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>
        <Container></Container>
      </div>
    </>
  );
}

export default Buy;
